var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.375q.417 0 .688-.292.27-.291.27-.666 0-.417-.27-.688-.271-.271-.688-.271-.417 0-.688.271-.27.271-.27.688 0 .375.27.666.271.292.688.292Zm-.708-4.75h1.416V12.208h-1.416Zm-4.834 10.708-7.791-7.791V14.458l7.791-7.791h11.084l7.791 7.791v11.084l-7.791 7.791Zm.584-1.416h9.916l6.959-6.959v-9.916l-6.959-6.959h-9.916l-6.959 6.959v9.916ZM20 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.f6a9f69263e333863441cbe823d9fdcd.svg";
export { ForwardRef as ReactComponent };